import React, { ReactNode } from 'react';
import styled from 'styled-components';

import mq from '../../../styles/breakpoints';
import Spacings from '../../../styles/Spacings';

interface Props {
  id?: string;
  children: ReactNode | ReactNode[];
  className?: string;
}

const ArticlePreviewsWrapper = ({
  id = 'articlePreviews',
  children,
  className,
}: Props) => {
  return (
    <Container
      id={id}
      itemsAmount={(children as ReactNode[]).length}
      className={className}
    >
      {children}
    </Container>
  );
};

export default ArticlePreviewsWrapper;

const Container = styled.div<{ itemsAmount?: number }>`
  display: grid;
  grid-column-gap: ${Spacings.XS};
  grid-row-gap: ${Spacings.S};
  grid-template-columns: repeat(1, 1fr);
  width: 100%;

  ${mq.from.breakpoint.M`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-row-gap: ${Spacings.S};
    grid-column-gap: ${Spacings.S};
  `}

  ${mq.from.breakpoint.L`
    grid-row-gap: ${Spacings.M};
    grid-column-gap: ${Spacings.M};

    ${({ itemsAmount }: { itemsAmount: number }) =>
      `grid-template-columns: repeat(${
        itemsAmount >= 4 ? 4 : 3
      },  minmax(0, 1fr))`}
  `}
`;
